export default __webpack_public_path__ + "static/media/fad-ram.8dbec44d.svg";